import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'epay-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.scss'],
})
export class PageContentComponent implements OnInit {
  @Input() pagetitle = '';

  constructor() {}

  ngOnInit() {}
}
